import Repository from "./Repository";

export default {
  createSession(data) {
    return Repository.post(`/api/v1/veriff/session`, data);
  },
};
